export default class UserAgentParser {
  constructor() {
    this.el = document.querySelector('#ua-parse');
    // this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.el.addEventListener('click', () => {
      this.uaStr = this.el.getAtribute('data-uastr');
      $.ajax({
        url: '/ajax.php',
        method: 'POST',
        type: 'html',
        data: {
          mode: 'uaInfo'
        },
        success: () => {}
      });
    });
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/useragentparser.js